import { Tooltip } from "@mui/material";
import React, { useState } from "react";

const HoverToDisplayFullTitle = ({ title, len }) => {
  return (
    <>
      {title?.length > len ? (
        <Tooltip title={title} arrow followCursor>
          {title}
        </Tooltip>
      ) : (
        title
      )}
    </>
  );
};

export default HoverToDisplayFullTitle;
